import { render, staticRenderFns } from "./Amc.vue?vue&type=template&id=c8e5de32&"
import script from "./Amc.vue?vue&type=script&lang=js&"
export * from "./Amc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports